import {isNil} from 'ramda';

import {GetWarehouseHandlingUnitsResponse} from '@dms/api/warehouse';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

export const getHandlingUnitLabel = (
  handlingUnitId: string | undefined,
  handlingUnits: GetWarehouseHandlingUnitsResponse | Nullish
): string => {
  if (isNil(handlingUnits)) {
    return EMPTY_PLACEHOLDER;
  }

  const selectedHandlingUnit = handlingUnits.find(
    (handlingUnit) => handlingUnit.id === handlingUnitId
  );

  const defaultHandlingUnit =
    handlingUnits.find((handlingUnit) => handlingUnit.isDefault)?.name ?? EMPTY_PLACEHOLDER;

  if (isNil(selectedHandlingUnit)) {
    return defaultHandlingUnit;
  }

  return selectedHandlingUnit.name;
};
